import { TrialHubHeader } from "../TrialHubHeader";
import { css } from "@emotion/react";

type Props = {
  children?: React.ReactNode;
  trialEndDate?: string | null;
};

const Styles = {
  content: css({
    padding: "30px 16px",
  }),
};

export const ActionsListView = ({ children, trialEndDate }: Props) => {
  return (
    <div>
      <TrialHubHeader
        title="Make the most of your trial"
        description="Your free trial unlocks access to Zapier's Premium features."
        trialEndDate={trialEndDate}
      />
      <div css={Styles.content}>{children}</div>
    </div>
  );
};
